import { useSelector } from 'react-redux';
import { IReduxStore } from '../interfaces/TReduxState';

export const useMainSelector = () => {
  return useSelector(({ main }: IReduxStore) => main);
};
